// extracted by mini-css-extract-plugin
export default {"img":"CertificateImage_img__SDoR0","img__mask":"CertificateImage_img__mask__2aw6I","title":"CertificateImage_title__0++js","loaderWrapper":"CertificateImage_loaderWrapper__QUjZi"};